export default __webpack_public_path__ + "static/media/avater_no_wall.76a7654a.png";